__turbopack_context__.v({
  "badge_active": "Variant-module__aT8v8a__badge_active",
  "badge_blue": "Variant-module__aT8v8a__badge_blue",
  "badge_blue__dark": "Variant-module__aT8v8a__badge_blue__dark",
  "badge_deleted": "Variant-module__aT8v8a__badge_deleted",
  "badge_disabled": "Variant-module__aT8v8a__badge_disabled",
  "badge_error": "Variant-module__aT8v8a__badge_error",
  "badge_green": "Variant-module__aT8v8a__badge_green",
  "badge_inactive": "Variant-module__aT8v8a__badge_inactive",
  "badge_mint": "Variant-module__aT8v8a__badge_mint",
  "badge_mint_light": "Variant-module__aT8v8a__badge_mint_light",
  "badge_neutral": "Variant-module__aT8v8a__badge_neutral",
  "badge_neutral__dark": "Variant-module__aT8v8a__badge_neutral__dark",
  "badge_neutral__light": "Variant-module__aT8v8a__badge_neutral__light",
  "badge_orange": "Variant-module__aT8v8a__badge_orange",
  "badge_outline": "Variant-module__aT8v8a__badge_outline",
  "badge_pending": "Variant-module__aT8v8a__badge_pending",
  "badge_primary": "Variant-module__aT8v8a__badge_primary",
  "badge_secondary": "Variant-module__aT8v8a__badge_secondary",
  "badge_tertiary": "Variant-module__aT8v8a__badge_tertiary",
});
